import script from "./Welcome.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=56a8c43c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a8c43c"]])

export default __exports__